<template>
  <page-view title="选取专家申请详情">
    <template slot="action" class="action">
      <a-space v-if="isExpertExtractAdmin || canEdit">
        <a-button icon="edit" @click="onEdit">编辑</a-button>
        <a-popconfirm placement="bottom" title="是否确认删除?" @confirm="onDel">
          <a-button :loading="attendLoading" icon="delete"
                    type="danger">删除
          </a-button>
        </a-popconfirm>
      </a-space>
    </template>
    <a-card>
      <div style="position: absolute;right: 29px;top: 13px;z-index: 99;">
        <img v-if="isDecrypt" style="width: 140px" :src="$_c + 'img/yes_decrypt.png'">
        <img v-else-if="isAttendAll && !isDecrypt" style="width: 140px" :src="$_c + 'img/no_decrypt.png'">
        <img v-else style="width: 140px" :src="$_c + 'img/extracting.png'">
      </div>
      <div class="titleCap">
        <div style="color: #262626" class="size6 mb-2">
          <span>{{ applyExpert.projectName }}
            <template v-if="applyExpert.projectCode">（<span
                style="font-weight: bold">{{ applyExpert.projectCode }}</span>）</template></span>&nbsp;
        </div>
        <div>
          <span class="mr-4">申请人：<a>{{ applyExpert.applyUserName || '未填写' }}</a></span>
          <span class="mr-4">申请时间：<a>{{ applyExpert.addDate | dayjs('YYYY-MM-DD') }}</a></span>
          <span>处理人：<a>{{ applyExpert.processUserName }}</a></span>
        </div>
      </div>
      <a-descriptions bordered size="small" :column="{ xxl: 3 }">
        <a-descriptions-item label="用途">
          {{
            applyExpert.applyType === ApplyTypeEnum.OTHER ?
                applyExpert.applyTypeOther : applyExpert.extras && applyExpert.extras.applyTypeText
          }}
        </a-descriptions-item>
        <a-descriptions-item label="采购方式">
          {{ applyExpert.extras && applyExpert.extras.purchaseMethodText }}
        </a-descriptions-item>
        <a-descriptions-item label="专家咨询电话">
          {{ applyExpert.reviewTelephone }}
        </a-descriptions-item>
        <a-descriptions-item :label="getApplyTypeLabel">
          {{ applyExpert.openDate | dayjs('YYYY-MM-DD HH:mm') }}
        </a-descriptions-item>
        <a-descriptions-item label="集合时间">
          {{ applyExpert.setOfTime | dayjs('YYYY-MM-DD HH:mm') }}
        </a-descriptions-item>
        <a-descriptions-item label="预计时长">
          {{ applyExpert.reviewDuration }}
        </a-descriptions-item>
        <a-descriptions-item label="需携带资料">
          {{ applyExpert.information }}
        </a-descriptions-item>
        <a-descriptions-item label="集合地点" :span="3">
          {{ applyExpert.setOfAddress }}
        </a-descriptions-item>
        <a-descriptions-item v-if="applyExpert.expertAge" label="年龄限制" :span="3">
          {{ applyExpert.expertAge }}岁以下
        </a-descriptions-item>
        <a-descriptions-item v-if="avoidExpertUnitData.length>0" label="回避单位" :span="3">
          <a-tag class="diyTag mt-1" v-for="item in avoidExpertUnitData" color="#07bfb8" style="font-size: 15px">
            {{ item.unitName }}<br>{{ item.creditCode }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="回避专家" v-if="avoidExpertData.length>0" :span="3">
          <a-tag class="diyTag mt-1" style="font-size: 15px" v-for="item in avoidExpertData" color="#15d7d0">
            {{ item.expertName }}<br>{{ item.idCard }}
          </a-tag>
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
    <a-card class="mt-3">
      <template slot="title">
        抽取结果
      </template>
      <template slot="extra">
        <a-space>
          <template v-if="isAttendAll">
            <template v-if="isDecrypt">
              <a-popconfirm v-if="isCanPushToBid" placement="top" title="是否确认重新推送采购平台?" @confirm="onExpertDecrypt(true)">
                <a-button  :loading="decryptLoading"
                > 已解密/推送采购平台
                </a-button>
              </a-popconfirm>
              <a-button v-else>已解密
              </a-button>
            </template>
            <template v-else>
            <a-popconfirm v-if="isCanPushToBid" placement="top" title="是否确认解密并推送采购平台?" @confirm="onExpertDecrypt(true)">
              <a-button type="primary" :loading="decryptLoading"
              > 解密/推送采购平台
              </a-button>
            </a-popconfirm>
              <a-popconfirm v-else placement="top" title="是否确认解密?" @confirm="onExpertDecrypt(false)">
                <a-button type="primary" :loading="decryptLoading"
                > 解密
                </a-button>
              </a-popconfirm>
            </template>
          </template>
          <a-dropdown v-if="isAttendAll && (isDecrypt || forceDecryptFlag ==='1')">
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <a-button type="primary" icon="export" @click="exportAllExtractExpert">
                  导出所有抽取专家Excel
                </a-button>
              </a-menu-item>
              <a-menu-item key="2">
                <a-button type="primary" icon="export" @click="exportExtractExpert">
                  导出抽取专家Doc
                </a-button>
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> 导出
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
          <a-button type="primary" icon="edit" :loading="initDataLoading"
                    @click="()=>{phoneLeaveVisible = true}">
            电话请假设置
          </a-button>
          <a-button type="primary" icon="sync" :loading="initDataLoading"
                    @click="()=>{loadData();$message.success('刷新成功')}">
            状态{{ timerId ? '(' + countdown + ')秒后' : '' }}刷新
          </a-button>
        </a-space>
      </template>
      <div
          style="text-align: center;font-size: 24px;color: #000;margin-top: -67px;margin-bottom: 50px;height: 36px"
          @click="onForceDecrypt">
        需抽取<b style="color: red">{{ applyExpert.expertNumber }}</b>人/已完成<b style="color: red">{{ attendNum }}</b>人
      </div>
      <div class="cqrs_box">
        <div class="item" v-for="item in purchaseData">
          <div class="title">
            <a-badge :offset="[2,-5]">
              <span v-if="item.extras.expertNum < item.applyNum" slot="count"
                    title="当前品类库内专家人数不足，系统将自动上溯抽取。">
                <a-icon type="exclamation-circle" theme="filled" style="color: red;font-weight: 100;font-size: 14px"/>
              </span>
              <span>{{ item.fspmmc }}</span>
              <span style="color: red;">（{{ GetCityFromLocation(item.extras.areaAddressText) }}）</span>
              <a-popover title="其他抽取条件" :overlayStyle="{  maxWidth: '600px' }" arrow-point-at-center
                         trigger="click">
                <template slot="content">
                  <span v-if="item.otherSourceLibrary">国家,省库:<p style="color: red">{{
                      item.extras.otherSourceLibrary
                    }}</p></span>
                  <span v-if="item.specificProfessionalTitleKey">职称名称:<p
                      style="color: red">{{ item.extras.specificProfessionalTitle }}</p></span>
                </template>
                <a v-if="item.otherSourceLibrary || item.specificProfessionalTitleKey">更多</a>
              </a-popover>
            </a-badge>
          </div>
          <div class="ry">
            <div class="img" v-for="item2 in item.expertList">
              <template>
                <template v-if="!item2">
                  <img :src="$_c + 'img/head1.svg'">
                  <span>暂未抽取</span>
                </template>
                <template v-else>
                  <template v-if="isDecrypt || forceDecryptFlag ==='1'">
                    <img style="cursor: pointer;" @click="onViewModal(item2)" :src="getAvatarUrl(item2.avatarUrlId)">
                    {{ item2.expertName }}
                  </template>
                  <template v-else-if="item2.expertFlag === ExtractExpertFlagEnum.ATTEND[0]">
                    <img :src="$_c + 'img/head2.svg'">
                    <span>{{ item2.expertFlagText }}</span>
                  </template>
                  <template v-else>
                    <img :src="$_c + 'img/head3.svg'">
                    <span>{{ item2.expertFlagText }}</span>
                  </template>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </a-card>
    <div class="mt-3" style="text-align: center">
      <a-button v-if="isCanExtract" @click="onPerExtract('0')" :loading="extractLoading" style="width: 200px"
                type="primary" size="large">抽取专家
      </a-button>
      <a-button style="width: 200px" type="primary" size="large"
                @click="openRedraw"
                :loading="redrawLoading"
                v-if="isCanRedrawExtract">补抽
      </a-button>
      <p style="color:red;" v-if="!isCanRedrawExtract && !isCanExtract && !isAttendAll">
        请等待所有抽中专家均有反馈结果后，才能启动下一轮补抽。 </p>
    </div>
    <a-card class="mt-3">
      <a-tabs type="card" :active-key="tabActiveKey" @change="(activeKey)=>{tabActiveKey = activeKey}"
              v-if="Object.keys(allExpertReasonListMap).length>0">
        <a-tab-pane :key="index+1+''" v-for="(info,index) in Object.keys(allExpertReasonListMap)">
          <div slot="tab">
            <a-badge show-zero :offset="[7,-3]" :number-style="{ backgroundColor: '#52c41a' }"
                     :title="getAttendNumTips(allExpertReasonListMap[info])"
                     :count="allExpertReasonListMap[info].filter(item=>expertAllAttendState.includes(item.expertFlag)).length ">
              {{ info }}
            </a-badge>
          </div>
          <a-popconfirm placement="bottom" title="是否确认呼叫?" @confirm="sendBatchIvr">
            <a-button type="primary" style="float: right" v-if="Object.keys(allExpertReasonListMap).length === index+1
               && !checkSendIvr(allExpertReasonListMap[info]) &&  !isCanExtract"
                      :loading="attendLoading"
            > 批量发起语音呼叫
            </a-button>
          </a-popconfirm>

          <table class="cq_table">
            <tr>
              <th>所属品目</th>
              <th>专家名称</th>
              <th>联系方式</th>
              <th>所在地</th>
              <th>抽取时间</th>
              <th>语音呼叫</th>
              <th>专家反馈 | 异常状态</th>
              <th>短信通知
                <a-popover v-if="ctiSmsVendor" title="短信结果回执">
                  <template slot="content">
                    <div>当前使用联通短信平台，该平台不会实时回</div>
                    <div>执短信结果,本系统会在早上8点到晚上22点之</div>
                    <div>间每隔15分钟获取一次短信结果,请耐心等待!!</div>
                  </template>
                  <a class="ml-2" style="text-decoration: underline;color: red">
                    注意
                  </a>
                </a-popover>
              </th>
              <th v-if="checkAttendExpert(allExpertReasonListMap[info]) || forceDecryptFlag ==='1'">操作</th>
            </tr>
            <tr v-for="item in allExpertReasonListMap[info]">
              <td>{{ item.selectPurchaseItemText }}</td>
              <td>{{ item.expertName }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.areaAddressText }}</td>
              <td>{{ item.addDate|dayjs('YYYY年MM月DD日 HH:mm') }}</td>
              <td><span style="color:red" v-if="item.callState ===CallStateEnum.NO_CALL_OUT[0]"> {{
                  item.callStateText
                }}</span>
                <span v-else>{{ item.callStateText }}</span>
                <a-popover v-if="item.simpleDyVmsPushLogVo && item.simpleDyVmsPushLogVo.length > 0 "
                           title="信息">
                  <template slot="content">
                    <p v-for="(log,index) in item.simpleDyVmsPushLogVo">第{{ index + 1 }}次发起时间:
                      {{ log.createTime | dayjs('YYYY年MM月DD日 HH:mm') }} 返回信息:
                      {{ log.responseMessage }}</p>
                  </template>
                  <a-icon type="info-circle"/>
                </a-popover>
                <a-popconfirm placement="bottom" title="是否确认呼叫?" @confirm="sendIvr(item)">
                  <a-button size="small"
                            v-if="([CallStateEnum.NO_CALL_OUT[0], CallStateEnum.FAIL_CALL_OUT[0]].includes(item.callState) &&
                                 item.expertFlag === ExtractExpertFlagEnum.EXTRACT[0] ||
                                  item.expertFlag === ExtractExpertFlagEnum.BUSY[0]) && forceDecryptFlag ==='1'  && Object.keys(allExpertReasonListMap).length === index+1"
                            :loading="attendLoading"
                            type="primary">发起语音
                  </a-button>
                </a-popconfirm>
              </td>
              <td>
                <template v-if="expertNormalState.includes(item.expertFlag)">
                  <a-tag
                      :color="ExtractExpertFlagEnum.getValOrCol(item.expertFlag).color">
                    {{ item.expertFlagText }}
                  </a-tag>
                  <!--                  <a-popover v-if="ExtractExpertFlagEnum.BUSY[0] === item.expertFlag"-->
                  <!--                             title="信息">-->
                  <!--                    <template slot="content">-->
                  <!--                      <p>专家接听并反馈不参加 或是 呼叫不成功</p>-->
                  <!--                    </template>-->
                  <!--                    <a-icon type="info-circle"/>-->
                  <!--                  </a-popover>-->
                </template>
                <template v-else>
                  <a-tag :color="ExtractExpertFlagEnum.ATTEND[2]">
                    {{ ExtractExpertFlagEnum.ATTEND[1] }}
                  </a-tag>
                  <a-divider type="vertical"/>
                  <a-tag :color="ExtractExpertFlagEnum.getValOrCol(item.expertFlag).color">
                    {{ item.expertFlagText }}
                  </a-tag>
                </template>
              </td>
              <td>
                <a-tag v-if="item.expertFlag === ExtractExpertFlagEnum.EXTRACT[0]">/
                </a-tag>
                <a-tag v-else-if="item.expertFlag === ExtractExpertFlagEnum.BUSY[0]">无需短信
                </a-tag>
                <template v-else>
                  <a-tag :color="ExtractExpertSmsEnum.getValOrCol(item.smsFlag).color">
                    {{ ExtractExpertSmsEnum.getValOrCol(item.smsFlag).value }}
                  </a-tag>
                  <a-popover v-if="ExtractExpertSmsEnum.SMS_FAIL[0] === item.smsFlag" title="提示">
                    <template slot="content">
                      <span style="color: red">{{ item.smsFailReason }}</span>
                    </template>
                    <a-icon type="info-circle"/>
                  </a-popover>
                  <a-popconfirm placement="top"
                                v-if="ExtractExpertSmsEnum.SMS_FAIL[0] === item.smsFlag"
                                @confirm="onReSendExpertSms(item.id)">
                    <template v-slot:title>
                      <p>是否确认对该专家重发送短信？</p>
                    </template>
                    <a-button size="small"
                              :loading="attendLoading"
                              type="primary">再次发送
                    </a-button>
                  </a-popconfirm>
                </template>
              </td>
              <td v-if="checkAttendExpert(allExpertReasonListMap[info]) || forceDecryptFlag ==='1'">
                <a-space>
                                    <a-popconfirm placement="top"
                                                  v-if="item.expertFlag === ExtractExpertFlagEnum.EXTRACT[0]"
                                                  @confirm="onAttend(item.id,ExtractExpertFlagEnum.ATTEND[0])">
                                      <template v-slot:okText>参加</template>
                                      <template v-slot:title>
                                        <p style="color: red">是否确认该专家参与项目评审？<br>该功能仅做状态调整，不触发语音和参加短信发送，望知悉！！！</p>
                                      </template>
                                      <a-button
                                          :loading="attendLoading"
                                          type="primary">参加
                                      </a-button>
                                    </a-popconfirm>
                  <a-button v-if="[CallStateEnum.NO_CALL_OUT[0], CallStateEnum.FAIL_CALL_OUT[0]].includes(item.callState)
                   && item.expertFlag === ExtractExpertFlagEnum.EXTRACT[0] && forceDecryptFlag ==='1'"
                            @click="onReplaceExpert(item)"
                            :loading="attendLoading"
                            type="primary">替换专家
                  </a-button>
                  <a-button
                      v-if="item.expertFlag === ExtractExpertFlagEnum.ATTEND[0] && (isDecrypt || forceDecryptFlag ==='1')"
                      @click="onOpenExpertFlag(item,false)"
                      :loading="attendLoading"
                      type="primary">状态设置
                  </a-button>
                </a-space>
              </td>
            </tr>
          </table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <not-attend-reason ref="attendRef" title="理由" :visible="attendVisible" @cancel="attendVisible = false"
                       @success="attendSuccess"/>
    <redraw-expert-modal :visible="redrawVisible" :applyId="id" @success="redrawSuccess"
                         :redraw-expert-num="applyExpert.expertNumber-expertReasonList.length "
                         @cancel="redrawVisible = false"/>
    <appoint-pact-modal ref="appointRef" :visible="appointVisible" @cancel="appointVisible = false"
                        @success="onPactSuccess"/>
    <appoint-extract-expert-modal ref="appointExtractRef" :visible="appointExtractVisible" :apply-id="id"
                                  @cancel="appointExtractVisible = false"
                                  @success="onAppointExtractSuccess"/>
    <set-expert-flag-modal ref="expertFlagRef" :visible="expertFlagVisible" @cancel="expertFlagVisible = false"
                           @success="expertFlagSuccess"/>
    <per-redraw-expert-modal ref="perRedrawRef" :visible="perRedrawVisible"
                             :redraw-expert-num="applyExpert.expertNumber-expertReasonList.length "
                             @cancel="perRedrawVisible = false" :apply-id="id"
                             @success="perRedrawSuccess"/>
    <per-appoint-expert-modal ref="perAppointRef" :visible="perAppointVisible"
                              @cancel="perAppointVisible = false" :apply-id="id"
                              @success="perAppointSuccess"/>
    <expertView-modal ref="expertView"
                      :visible="evmVisible"
                      :fromType="ExpertFromType.EXPERT_LIST"
                      @success="evmVisible = false"
                      @openEdit="openEdit"
                      @cancel="evmVisible = false"/>
    <expert-edit ref="expertEditRef" @openViewExpert="openViewExpert"/>
    <replace-extract-expert-modal ref="replaceExtractRef" :visible="replaceExtractVisible" :apply-id="id"
                                  @cancel="replaceExtractVisible = false"
                                  @success="onReplaceExtractSuccess"/>
    <phone-leave-set-modal ref="phoneLeaveRef" :visible="phoneLeaveVisible" @cancel="phoneLeaveVisible = false"
                           :apply-id="id" @onOpenExpertFlag="onOpenExpertFlag"
                           @success="phoneLeaveSuccess"/>
    <a-modal v-model="selectVisible" title="提示">
      <template slot="footer">
        <a-button key="1" type="primary" :loading="selectRedrawLoading" @click="onOpenRedrawItem">
          切换品目补抽
        </a-button>
        <a-button key="2" type="primary" :loading="selectAppointLoading" @click="openAppointExtract(undefined)">
          手工选择其他专家
        </a-button>
        <a-button key="3" @click="selectVisible = false">
          取消
        </a-button>
      </template>
      <p style="color: red;font-size: 16px">库内符合要求的专家数量不足，请人工选择补抽方式。</p>
    </a-modal>
  </page-view>
</template>
<script>
import { PageView } from '@/layouts'
import PerAppointExpertModal from '@/epp/expertmain/selectexpertapply/modal/PerAppointExpertModal.vue'
import PerRedrawExpertModal from '@/epp/expertmain/selectexpertapply/modal/PerRedrawExpertModal.vue'
import AppointExtractExpertModal from '@/epp/expertmain/selectexpertapply/modal/AppointExtractExpertModal.vue'
import WorkflowMenu from '@/components/workflow/WorkflowMenu.vue'
import WorkflowComment from '@/components/workflow/WorkflowComment.vue'
import NotAttendReason from '@/epp/expertmain/selectexpertapply/modal/NotAttendReason.vue'
import RedrawExpertModal from '@/epp/expertmain/selectexpertapply/modal/RedrawExpertModal.vue'
import AppointPactModal from '@/epp/expertmain/selectexpertapply/modal/AppointPactModal.vue'
import SetExpertFlagModal from '@/epp/expertmain/selectexpertapply/modal/SetExpertFlagModal.vue'
import {
  ApplyTypeEnum,
  CallStateEnum, ExtractExpertFlagEnum, ExtractExpertSmsEnum,
  ExtractRecordLevelEnum, GetCityFromLocation, SMS_VENDOR_MAP
} from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import {
  AutoRedrawExpert,
  ConfirmExpertFlag, DeleteSelectExpertApply, ExtractExpert, ExtractExpertDecrypt,
  GetSelectExpertApplyList, PushExtractExpert,
  ReSendExpertSms, SelectRedrawExtractItem, SendBatchIvrCall, SendSingleIvrCall
} from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'
import { ExpertExcel } from '@/epp/export/ExpertUtil'
import $ from 'jquery'
import ExpertUploadView from '@/components/selector/ExpertUploadView.vue'
import expertViewModal from '@/epp/expertmain/expertInfo/common/ExpertViewModal.vue'
import { ExpertFromType } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import ExpertEdit from '@/epp/expertmain/expertInfo/ExpertEdit.vue'
import ReplaceExtractExpertModal from '@/epp/expertmain/selectexpertapply/modal/ReplaceExtractExpertModal.vue'
import PhoneLeaveSetModal from '@/epp/expertmain/selectexpertapply/modal/PhoneLeaveSetModal.vue'
import { IsExpertExtractAdmin } from '@/epp/expertmain/userperm/UserPermUtil'
import { QueryMetadataList } from '@/api/componentsApi'

export default {
  name: 'SelectExpertApplyView',
  components: {
    PhoneLeaveSetModal,
    ReplaceExtractExpertModal,
    ExpertEdit,
    expertViewModal,
    ExpertUploadView,
    PerAppointExpertModal,
    PerRedrawExpertModal,
    AppointExtractExpertModal,
    PageView,
    WorkflowMenu,
    WorkflowComment,
    NotAttendReason,
    RedrawExpertModal,
    AppointPactModal,
    SetExpertFlagModal
  },
  data () {
    return {
      id: this.$route.query.id,
      forceDecryptFlag: this.$route.query.forceDecryptFlag,
      user: this.$ls.get('user'),
      xwfState: {},
      applyExpert: {},
      purchaseData: [],
      avoidExpertData: [],
      avoidExpertUnitData: [],
      expertReasonList: [],//正常专家（参加，抽取）
      allExpertReasonList: [],//全部专家
      abnormalExpertReasonList: [],//异常专家（请假，回避，缺席，不参加）
      recordList: [],
      allExpertReasonListMap: {},//全部专家
      attendLoading: false,
      decryptLoading: false,
      redrawLoading: false,
      hasWf: false,
      attendVisible: false,
      redrawVisible: false,
      appointVisible: false,
      appointExtractVisible: false,
      expertFlagVisible: false,
      perRedrawVisible: false,
      perAppointVisible: false,
      shiftKey: false,
      ctrlKey: false,
      visible: true,
      extractLoading: false,
      initDataLoading: false,
      CallStateEnum,
      evmVisible: false,
      openEditExpertId: undefined,
      selectVisible: false,
      selectAppointLoading: false,
      selectRedrawLoading: false,
      tabActiveKey: '0',
      replaceExtractVisible: false,
      phoneLeaveVisible: false,
      //定时刷新器
      timerId: null,
      countdown: 10,
      executeCount: 30,
      canEdit:false,
      ctiSmsVendor:false //是否是联通短信,目前支持阿里云和联通
    }
  },
  created () {
    this.loadData()
    //监听shift/ctrl按键按住
    document.addEventListener('keydown', e => {
      this.shiftKey = e.ctrlKey
      this.ctrlKey = e.ctrlKey
    })
    //监听shift/ctrl按键松开
    document.addEventListener('keyup', e => {
      this.shiftKey = e.ctrlKey
      this.ctrlKey = e.ctrlKey
    })
    this.checkSmsVendor()
  },
  beforeUnmount () {
    this.onClearInterval()
  },
  computed: {
    ExpertFromType () {
      return ExpertFromType
    },
    ApplyTypeEnum () {
      return ApplyTypeEnum
    },
    ExtractRecordLevelEnum () {
      return ExtractRecordLevelEnum
    },
    ExtractExpertSmsEnum () {
      return ExtractExpertSmsEnum
    },
    ExtractExpertFlagEnum () {
      return ExtractExpertFlagEnum
    },
    //是否要显示正常抽取的按钮
    isCanExtract () {
      //首次未抽取或者首次以人工抽取的形式 且未完成抽取
      return this.recordList.length === 0 || this.recordList.length === 1 && (this.recordList[0].state === '0' || this.recordList[0].extractType === '2') && !this.isSuccessExtract
    },
    //是否要显示补抽取的按钮
    isCanRedrawExtract () {
      return !this.isCanExtract && !this.isSuccessExtract && this.expertReasonList.filter(item => ExtractExpertFlagEnum.EXTRACT[0] === item.expertFlag).length === 0
    },
    //是否能够进行编辑
    isCanEdit () {
      this.canEdit = this.recordList.length === 0
      return this.recordList.length === 0
    },
    //是否完成抽取
    isSuccessExtract () {
      return this.expertReasonList.length >= this.applyExpert.expertNumber
    },
    //是否解密
    isDecrypt () {
      return this.applyExpert.decryptFlag === '1'
    },
    //已参加人数
    attendNum () {
      return this.expertReasonList.filter(item => ExtractExpertFlagEnum.ATTEND[0] === item.expertFlag).length
    },
    //是否已全部参加
    isAttendAll () {
      return this.attendNum >= this.applyExpert.expertNumber
    },
    //专家状态[正常状态][异常状态]分两部分 等待反馈 参加 不参加
    expertNormalState () {
      return [ExtractExpertFlagEnum.EXTRACT[0], ExtractExpertFlagEnum.ATTEND[0], ExtractExpertFlagEnum.BUSY[0]]
    },
    //专家状态[正常状态][异常状态]分两部分 请假 缺席 回避
    expertAbnormalState () {
      return [ExtractExpertFlagEnum.LEAVE[0], ExtractExpertFlagEnum.AVOID[0], ExtractExpertFlagEnum.ABSENCE[0]]
    },
    //专家状态 参加 请假 缺席 回避  都为参加
    expertAllAttendState () {
      let arr = []
      arr.push(ExtractExpertFlagEnum.ATTEND[0])
      return arr
    },
    //是否是抽取管理员
    isExpertExtractAdmin () {
      return IsExpertExtractAdmin()
    },
    //是否还有待反馈的抽取专家
    isHasExtractExpert () {
      return this.expertReasonList.filter(item => ExtractExpertFlagEnum.EXTRACT[0] === item.expertFlag).length === 0
      && this.expertReasonList.filter(item => ExtractExpertFlagEnum.ATTEND[0] === item.expertFlag &&
              [ExtractExpertSmsEnum.SMS_NO_SEND[0], ExtractExpertSmsEnum.SMS_DOING_SEND[0]].includes(item.smsFlag)).length === 0

    },
    //是否能推送到招标系统
    isCanPushToBid () {
      return !!this.applyExpert.outId && this.applyExpert.applyType === ApplyTypeEnum.PROJECT_REVIEW
    },
    getApplyTypeLabel () {
      return ApplyTypeEnum.PROJECT_REVIEW === this.applyExpert.applyType ? '开标时间' : '活动时间'
    },
  },
  watch: {
    isHasExtractExpert: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.onClearInterval()
        }
      },
      deep: true,// 深度监听
      immediate: true //初始化时立即执行
    }
  },
  methods: {
    async checkSmsVendor () {
      const metadata = await QueryMetadataList('sms', 'vendor')
      if (metadata.code === 200) {
        this.ctiSmsVendor = metadata.result[0].value && metadata.result[0].value === SMS_VENDOR_MAP.cti
      }
    },
    GetCityFromLocation,
    //检查专家是否已经全部发送语音
    checkSendIvr (expertList) {
      let data = expertList.filter(item => item.callState === CallStateEnum.NO_CALL_OUT[0])[0]
      return !data
    },
    //检查当前轮次是否有参加的专家
    checkAttendExpert (expertList) {
      let data = expertList.filter(item => ExtractExpertFlagEnum.ATTEND[0] === item.expertFlag)[0]
      return !!data
    },
    //获取当前轮次提示
    getAttendNumTips (expertList) {
      let len = expertList.filter(item => this.expertAllAttendState.includes(item.expertFlag)).length
      return len ? '本轮有' + len + '位专家同意参加' : '本轮暂无确认参加的专家'
    },
    //打开窗口查看信息
    onViewModal (record) {
      this.evmVisible = true
      this.$refs.expertView.loadData(record.expertId)
    },
    //关闭修改或保存修改后打开窗口查看信息
    openViewExpert () {
      this.evmVisible = true
      this.$refs.expertView.loadData(this.openEditExpertId)
    },
    openEdit (id) {
      this.openEditExpertId = id
      this.$refs.expertEditRef.loadData(id)
    },
    //替换专家回调
    onReplaceExtractSuccess () {
      this.replaceExtractVisible = false
      this.loadData()
    },
    //电话请假回调
    phoneLeaveSuccess () {
      this.phoneLeaveVisible = false
    },
    //获取头像地址
    getAvatarUrl (fileId) {
      if (fileId) {
        return process.env.VUE_APP_WEB_SERVER + '/api/1/attachment/download?id=' + fileId
      }
      return require('@/assets/head.jpg')
    },
    onLoadXWFState (xwfState) {
      this.xwfState = xwfState
    },
    //加载页面数据
    async loadData () {
      let that = this
      try {
        that.initDataLoading = true
        let res = await GetSelectExpertApplyList(that.id, this.forceDecryptFlag)
        if (res.code !== 200) {
          return
        }
        that.applyExpert = { ...res.result.expertApply }
        that.purchaseData = [...res.result.itemList]
        that.avoidExpertData = [...res.result.avoidList]
        that.avoidExpertUnitData = [...res.result.avoidUnitList]
        //全部的专家
        that.allExpertReasonList = [...res.result.expertReasonList]
        that.allExpertReasonListMap = this.convertToMap(that.allExpertReasonList)
        //抽取和参加的专家
        let expertFlag = [ExtractExpertFlagEnum.EXTRACT[0], ExtractExpertFlagEnum.ATTEND[0]]
        that.expertReasonList = [...that.allExpertReasonList.filter(item => expertFlag.includes(item.expertFlag))]
        //异常专家
        that.abnormalExpertReasonList = [...that.allExpertReasonList.filter(item => !item.expertFlag.includes(expertFlag))]
        //添加专家到品目中
        that.addExpertToItem(that.purchaseData)
        that.recordList = [...res.result.recordList]
        this.tabActiveKey = Object.keys(that.allExpertReasonListMap).length + ''
        that.hasWf = res.result.hasWf
        // that.$nextTick(() => {
        //   that.onMergeCol()
        // })
      } catch (e) {
        that.$message.error('数据加载失败！！！')
      } finally {
        that.initDataLoading = false
      }
    },
    //添加专家到品目中
    addExpertToItem (purchaseData) {
      let expertFlag = [ExtractExpertFlagEnum.EXTRACT[0], ExtractExpertFlagEnum.ATTEND[0]]
      purchaseData.forEach(item => {
        let expertList = this.allExpertReasonList.filter(expert => expertFlag.includes(expert.expertFlag)
            && expert.targetItemId === item.id)
        item.expertList = [...expertList]
        for (let i = 0; i < item.applyNum - expertList.length; i++) {
          item.expertList.push(null)
        }
      })
    },
    convertToMap (expertReasonList) {
      // 使用reduce方法将相同id的对象合并
      return expertReasonList.reduce((acc, obj) => {
        //根据抽取次数分类
        if (acc[obj.extractRound]) {
          acc[obj.extractRound].push(obj)
        } else {
          // 如果不存在，直接添加到map中
          acc[obj.extractRound] = [obj]
        }
        return acc
      }, {})
    },

    //设置专家是否参加评审
    onAttend (id, expertFlag) {
      const data = {
        id: id,
        expertFlag: expertFlag,
      }
      this.onPostAttend(data)
      // //如果参加
      // if (ExtractExpertFlagEnum.ATTEND === expertFlag) {
      //   this.onPostAttend(data)
      //   return true
      // }
      // //打开原因输入窗口
      // this.attendVisible = true
      // this.$refs.attendRef.initData(data)
    },
    /**
     * 重新发送专家短信
     * @param {String} id - 相关的ID，用于指定要重新发送的专家短信
     * @description 尝试重新发送指定ID的专家短信，如果发送失败则显示错误消息，成功则显示成功消息并加载数据。
     */
    async onReSendExpertSms (id) {
      try {
        // 请求重新发送专家EMS邮件
        let res = await ReSendExpertSms(id)
        // 检查发送结果，如果失败则显示错误信息并返回
        if (200 !== res.code) {
          this.$message.error('重发失败')
          return
        }
        this.$message.success('重发成功')
      } catch (e) {
        // 捕获并显示任何在发送过程中发生的错误
        this.$message.error(e.message)
      } finally {
        // 无论成功或失败，最后都加载数据
        await this.loadData()
        this.onSetInterval()
      }
    },
    //请求专家是否参加评审
    async onPostAttend (data) {
      try {
        this.attendLoading = true
        let res = await ConfirmExpertFlag(data)
        if (200 !== res.code) {
          this.$message.error('设置失败')
          return
        }
        this.$message.success('设置成功')
        await this.loadData()
      } catch (e) {
        this.$message.error(e)
      } finally {
        this.attendLoading = false
      }
    },
    //发送单个语音通知
    async sendIvr (data) {
      debugger
      try {
        let form = {
          ...data,
        }
        this.attendLoading = true
        let res = await SendSingleIvrCall(form)
        if (200 !== res.code) {
          this.$error({
            title: '错误提示',
            content: res.msg,
          })
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.attendLoading = false
        // 无论成功或失败，最后都加载数据
        await this.loadData()
      }
    },
    //批量发起语音
    async sendBatchIvr () {
      try {
        let form = {
          applyId: this.id,
        }
        this.attendLoading = true
        let res = await SendBatchIvrCall(form)
        if (200 !== res.code) {
          this.$error({
            title: '错误提示',
            content: res.msg,
          })
          return
        }
        this.$info({
          title: '提示',
          content: '已发送语音邀请，请耐心等待专家的反馈',
        })
        //开启定时器
        this.onSetInterval()
      } catch (e) {
        this.$message.error(e)
      } finally {
        this.attendLoading = false
        // 无论成功或失败，最后都加载数据
        await this.loadData()
      }
    },
    //解密并 推送操作
    async onExpertDecrypt (pushFlag) {
      try {
        this.decryptLoading = true
        let res = await ExtractExpertDecrypt(this.id,pushFlag)
        if (200 === res.code) {
          await this.loadData()
        }
        this.$info({
          title: '温馨提醒',
          content: res.msg
        })
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.decryptLoading = false
      }
    },

    //替换专家
    onReplaceExpert (item) {
      this.replaceExtractVisible = true
      this.$refs.replaceExtractRef.onLoadData(item.id)
    },
    //打开专家状态窗口
    onOpenExpertFlag (record, onlyLeave) {
      this.expertFlagVisible = true
      this.$refs.expertFlagRef.initData(record, onlyLeave)
    },
    onEdit () {
      this.$router.push({ path: `/selectExpertApply/edit?id=${this.id}` })
    },
    //跳转页面
    onForceDecrypt () {
      if (this.ctrlKey) {
        var routeIndex = this.$router.resolve({
          path: '/selectExpertApply/view',
          query: { id: this.id, forceDecryptFlag: '1' }
        })
        window.open(routeIndex.href, '_blank')
      }
    },
    onPerExtract (isLevel) {
      let that = this
      this.$confirm({
        title: '确认抽取?',
        onOk () {
          that.onExtractExpert(isLevel)
        },
      })
    },
    //抽取专家
    async onExtractExpert (isLevel) {
      if (this.shiftKey) {
        await this.openAppointExtract(isLevel)
        return
      }
      try {
        this.extractLoading = true
        let res = await ExtractExpert(this.id)
        if (200 === res.code) {
          this.showExtractResult(res.result)
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        await this.loadData()
        this.extractLoading = false
      }
    },
    //打开指定抽取窗口
    async openAppointExtract (isLevel) {
      this.selectAppointLoading = true
      let resRedraw = await this.onOpenRedraw(isLevel)
      if (resRedraw.code !== 200) {
        return
      }
      if (!resRedraw.result || resRedraw.result.length === 0) {
        this.$error({
          title: '抽取提示',
          content: '已经抽取完成了，请勿重复抽取'
        })
        return
      }
      if (resRedraw.result.length === 1) {
        //如果只有一个品目，则直接选补抽人员
        this.$refs.appointExtractRef.onLoadData(isLevel, this.applyExpert.expertNumber - this.expertReasonList.length, true, resRedraw.result)
        this.appointExtractVisible = true
      } else {
        this.$refs.perAppointRef.initData(isLevel, resRedraw.result)
        this.perAppointVisible = true
      }
      this.selectAppointLoading = false
      this.selectVisible = false
    },
    //打开补抽窗口
    async onOpenRedrawItem () {
      this.selectRedrawLoading = true
      let resRedraw = await this.onOpenRedraw()
      if (resRedraw.code !== 200) {
        return
      }
      //如果只有一个品目，则直接选补抽品目
      // if (resRedraw.result.length === 1) {
      //   this.redrawVisible = true
      // } else {
      this.$refs.perRedrawRef.initData(resRedraw.result)
      this.perRedrawVisible = true
      this.selectRedrawLoading = false
      this.selectVisible = false
    },

    /**
     * 自动补抽操作
     * @returns {Promise<void>}
     */
    async openRedraw () {
      if (this.shiftKey) {
        await this.openAppointExtract()
        return
      }
      try {
        this.redrawLoading = true
        let res = await AutoRedrawExpert({ applyId: this.id })
        if (200 !== res.code) {
          this.$error({
            title: '错误提示',
            content: res.msg || '补抽失败，请联系管理员'
          })
          return
        }
        //抽取不到专家，切换新品目进行抽取
        if (!res.result.extractNum) {
          this.selectVisible = true
          return
        }
        this.showExtractResult(res.result)
        await this.loadData()
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.redrawLoading = false
      }
    },

    //推送专家到快采
    async onPushExpert () {
      let res = await PushExtractExpert(this.id)
      if (200 === res.code) {
        this.$message.success('推送成功')
      }
    },
    // 删除处理
    async onDel () {
      this.attendLoading = true
      const res = await DeleteSelectExpertApply(this.id)
      this.attendLoading = false
      if (res.code === 200) {
        this.$message.success('删除成功')
        await this.$router.push({ path: '/selectExpertApply/index' })
      } else {
        this.$message.error('删除失败')
      }
    },
    //补抽回调
    redrawSuccess (result) {
      this.redrawVisible = false
      this.showExtractResult(result)
      this.loadData()
    },
    //显示抽取后结果
    showExtractResult (result) {
      let extraMsg = result.successFlag ? '' : `品目${result.overItemName.map(item => `【${item}】`)}符合要求的库内专家数量不足，待本轮抽取的专家全部反馈结果后，您必须人工介入并再次补抽。`
      this.$info({
        title: '抽取结果',
        content: h =>
            <div style="color:green;font-size:16px">当前抽取结果为{result.extractProgress}<p
                style="color:red;">{extraMsg}</p></div>,
      })
    },
    //手工设置专家是否参加-点击确定后，输入值回传
    attendSuccess (data) {
      this.onPostAttend(data)
      this.attendVisible = false
    },
    //手工设置专家状态，点击确定后，刷新页面
    expertFlagSuccess () {
      this.expertFlagVisible = false
      this.loadData()
      if (this.$refs.phoneLeaveRef) {
        this.$refs.phoneLeaveRef.clearMethod(false)
        if (this.phoneLeaveVisible) {
          this.phoneLeaveVisible = false
        }
      }
    },
    //指定抽取值回传
    onPactSuccess () {
      this.appointVisible = false
      this.appointExtractVisible = true
    },
    //指定抽取成功
    onAppointExtractSuccess () {
      this.appointExtractVisible = false
      this.loadData()
    },
    async onOpenRedraw (isLevel) {
      //检查返回的品目剩几个
      try {
        let res = await SelectRedrawExtractItem({ isLevel: isLevel, applyId: this.id })
        if (200 !== res.code) {
          this.$error({
            title: '错误提示',
            content: res.message || '获取剩余品目数据失败'
          })
          return
        }
        if (res.result.length === 0) {
          this.$warning({
            title: '抽取提示',
            content: '您已经抽取完成了',
          })
          return
        }
        return res
      } catch (e) {
        this.$message.error(e.message)
      } finally {
      }
    },
    //补抽前置选择回调
    perRedrawSuccess (result) {
      this.perRedrawVisible = false
      // 如果发送成功，展示提取结果，并尝试显示结果
      this.showExtractResult(result)
      this.loadData()
    },
    //指定抽取前置选择回调
    perAppointSuccess () {
      this.perAppointVisible = false
      this.loadData()
    },

    //导出抽取专家信息
    exportExtractExpert () {
      const that = this
      let path = '/api/1/expertmain/selectExpertApply/exportExtractExpertDoc'
      ExpertExcel(that, path, { applyId: this.id, forceDecryptFlag: this.forceDecryptFlag }, '专家信息.docx')
    },
    exportAllExtractExpert () {
      const that = this
      let path = '/api/1/expertmain/extractExpert/exportExtractExpert'
      ExpertExcel(that, path, { applyId: this.id, forceDecryptFlag: this.forceDecryptFlag }, '全部抽取专家信息.xlsx')
    },
    onMergeCol () {
      this.MergeCol_v1('#table1', 0, 0)
      if (document.getElementById('allTable')) {
        this.openColl()
      }
    },
    MergeCol_v1 (tableid, startColIdx, colIdx) {
      var that
      $(tableid + ' tr').each(function (row) {
        /* 取该行下的指定列单元格 */
        $(this).find('td:eq(' + colIdx + ')').each(function (col) {
          this.removeAttribute('rowSpan')
          $(this).show()
          /* 临时存储当前单元格内容 判断如果与上一次循环取得的内容相同时 */
          if (that != null && $(this).text() === $(that).text()) {

            /* 为当前单元格添加 rowspan 属性 */
            var rowspan = that.getAttribute('rowSpan') || 1
            /* 如果已经存在 rowspan 属性，则值 + 1 */
            rowspan = Number(rowspan) + 1
            that.setAttribute('rowSpan', rowspan)
            /* 如果是第二列也就是大类名称那一列 也将最后一列合并*/
            /* 隐藏当前单元格 */
            $(this).hide()
          } else {
            /* 第一次循环 或 单元格内容与上一次不同时 更新 that 的值 */
            that = this
          }
        })
      })
      /* 自调用 */
      if (colIdx > startColIdx) {
        colIdx -= 1
        this.MergeCol_v1(tableid, startColIdx, colIdx)
      }
    },
    openColl (val) {
      this.$nextTick(() => {
        this.MergeCol_v1('#allTable', 0, 0)
      })
    },

    // 启动定时器，每5秒执行一次
    onSetInterval () {
      this.timerId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown-- // 倒计时减少
        } else {
          //当执行次数小于0时，清除定时器
          if (this.executeCount < 0) {
            this.onClearInterval()
          }
          this.loadData() // 倒计时归零时执行任务
          this.executeCount--
          this.countdown = 10 // 重置倒计时
        }
      }, 1000)
    },
    //关闭定时器
    onClearInterval () {
      if (this.timerId) {
        console.log('清除定时任务')
        clearInterval(this.timerId)
        this.timerId = null
      }
    }
  }
}
</script>
<style lang="less" scoped>


/deep/ .ant-descriptions-item-label {
  width: 120px;
}

/deep/ .ant-popover-inner-content {
  white-space: normal; /* 允许文本换行 */
  word-wrap: break-word; /* 长单词换行 */
  max-height: 60vh; /* 限制最大高度 */
  overflow-y: auto; /* 添加滚动条 */
}

.cqrs_box {
  display: flex;
  justify-content: center;

  .item {
    text-align: center;
    margin: 0 12px;

    .title {
      background: #f5f5f5;
      padding: 8px;
      margin-bottom: 24px;
      position: relative;

      &::after {
        content: "";
        width: 1px;
        height: 12px;
        background: #e6e6e6;
        position: absolute;
        bottom: -12px;
        margin: auto;
        left: 0;
        right: 0;
      }
    }

    .ry {
      display: flex;
      justify-content: center;

      .img {
        width: 90px;
        //display: flex;
        //align-items: center;
        //justify-content: center;
        //flex-direction: column;
        margin: 0 8px;
        position: relative;

        img {
          width: 100%;
          height: 118px;
          object-fit: cover;
          display: block;
        }

        span {
          display: block;
          text-align: center;
        }

        p {
          font-size: 12px;
          margin-top: 10px;
          color: #6e6e6e;
          margin-bottom: -10px;
        }

        i {
          font-size: 40px;
          font-weight: bold;
          color: #1f76ff;
          border: 2px solid rgba(192, 192, 192, 0.32);
          border-radius: 100%;
        }

        &::after {
          content: "";
          width: 1px;
          height: 12px;
          background: #e6e6e6;
          position: absolute;
          top: -12px;
          margin: auto;
          left: 0;
          right: 0;
        }

        &::before {
          content: "";
          width: 100%;
          box-sizing: content-box;
          padding: 0 8px;
          height: 1px;
          background: #e6e6e6;
          position: absolute;
          top: -12px;
          left: 50%;
          margin: auto;
        }

        &:nth-last-child(1)::before {
          display: none;
        }
      }
    }
  }
}

.hx {
  animation: breathe 2s infinite;
}

@keyframes breathe {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

.titleCap {
  margin-bottom: 12px;

  .receiveNum {
    padding-left: 16px;
  }

  > span {
    border-right: 1px solid #e6e6e6;
    padding: 0 20px;
  }

  > span:nth-last-child(1) {
    border-right: none;
  }

  > span:nth-child(2) {
    padding-left: 0;
  }
}

</style>
